<template>
	<div>
    <div id="bee-plugin-container" class="bee-plugin-container"></div>
	</div>
</template>

<script>
import Bee from 'bee-plugin'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import groupModel from 'models/group'
import L from 'services/Localization'

export default {
  name: 'bee',
  props: {
    clientId: {
      type: String,
      required: true
    },
    clientSecret: {
      type: String,
      required: true
    },
    layout: {
      type: [Object, String],
      required: true
    }
  },
  data() {
    return {
      beeConfig: {
        uid: 'test1-clientside',
        container: 'bee-plugin-container',
        language: 'en-US',
        mergeTags: [],
        autosave: 120,
        onSave: (jsonFile, htmlFile) => this.onSave(jsonFile, htmlFile),
        onAutoSave: (jsonFile) => this.onAutoSave(jsonFile),
        onError: (errorMessage) => this.onError(errorMessage)
      }
    }
  },
  computed: {
    ...mapGetters({
      groups: 'allGroups'
    })
  },
  mounted() {
    this.$store.dispatch('getAllGroups').then(() => {
      this.beeConfig.mergeTags = groupModel.extractProperties(this.groups, this.buildMergeTag)
      this.beeConfig.specialLinks = [{
        type: L.localize('Bee_Subscription'),
        label: L.localize('Bee_Unsubscribe'),
        link: '{{ unsubscribe_url }}'
      }]
      let beeInstance = new Bee()
      if (!_.isEmpty(this.layout.src)) {
        window.abp.ajax({url: this.layout.src, type: 'GET'}).then((response) => {
          beeInstance.getToken(this.clientId, this.clientSecret)
            .then((template) => beeInstance.start(this.beeConfig, response))
        })
      } else if (_.isString(this.layout)) {
        beeInstance.getToken(this.clientId, this.clientSecret)
            .then((template) => beeInstance.start(this.beeConfig, JSON.parse(this.layout)))
      } else {
        beeInstance.getToken(this.clientId, this.clientSecret)
            .then((template) => beeInstance.start(this.beeConfig, this.layout))
      }
    })
  },
  methods: {
    buildMergeTag: function(property) {
      return {
        name: property.label,
        value: `{{ ${property.title} }}`
      }
    },
    onSave: function(jsonFile, htmlFile) {
      let data = { json: jsonFile, html: htmlFile }
      this.$emit('onSave', data)
    },
    onAutoSave: function(jsonFile) {
      this.$emit('onAutoSave', { json: jsonFile })
    },
    onError: function() {
      console.log('onSave')
    }
  }
}
</script>

<style lang='scss'>
#bee-plugin-container {
  overflow:hidden;
  position: absolute;
  top:0px;
  bottom:0px;
  left:0px;
  right:0px;
  z-index:999;
}
#integrator-bottom-bar {
  position: absolute;
  height: 25px;
  bottom:0px;
  left:5px;
  right:0px;
}

.top-bar-left .title{
  display: none;
}
</style>



// WEBPACK FOOTER //
// Bee.vue?6bb27eda